import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ParamTable from '../ParamTable';
import { CodeHighlighter } from '../index';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const SSOV3 = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Grid
        container
        item
        xs={12}
        spacing={2}
        justifyContent={'space-between'}
      >
        <Grid
          item
          xs={2}
        >
          <h3>Example Request</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <ParamTable
            rows={[
              { name: 'partnerUserId', type: 'string', description: 'A unique identifier from your database' },
              { name: 'email', type: 'string', description: 'Patient’s Email' },
              { name: 'firstName', type: 'string', description: 'Patient’s First Name' },
              { name: 'lastName', type: 'string', description: 'Patient’s Last Name' },
              { name: 'height', type: 'integer', description: 'Patient’s Height in cm' },
              { name: 'weight', type: 'integer', description: 'Patient’s Weight in kgs' },
              { name: 'age', type: 'integer', description: 'Patient’s Age' },
              { name: 'DOB', type: 'date', description: 'Patient’s Date of Birth formatted as YYYY-MM-DD' },
              { name: 'postalCode', type: 'string', description: 'Patient’s Postal Code' },
              {
                name: 'gender',
                type: '’male’ | ’female’ | ’nonBinary’ | ’PreferToSelfDescribe’ | ’PreferNotToAnswer’',
                description: 'Patient’s Gender',
              },
              { name: 'desiredUsername', type: 'string', description: 'Patient’s Desired Username' },
              {
                name: 'activityLevel',
                type: "'Sedentary' | 'BelowGuidelines' | 'MeetsGuidelines' | 'AboveGuidelines' | 'HighlyActive'",
                description: 'Patient’s Activity Level',
              },
              { name: 'weightTrend', type: "'Falling' | 'Constant' | 'Rising'", description: 'Patient’s Weight Trend' },
              { name: 'healthGoals', type: 'array', description: 'Patient’s Health Goals found via /goals' },
              {
                name: 'chronicConditions',
                type: 'array',
                description: 'Patient’s Chronic Conditions that may impact their goals',
              },
              {
                name: 'additionalParams',
                type: 'json',
                description: 'Custom object you wish to attach to the Patient',
              },
              {
                name: 'redirectUri',
                type: 'uri',
                description: '(Optional) Where to redirect the Patient after assessment completion',
              },
            ]}
          />
        </Grid>
        <Grid
          item
          xs={2}
        >
          <h3>Raw Request</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <CodeHighlighter
            code={`curl -X POST https://api-prod.dietid.com/api/v3/sso
                      -H 'Content-Type: application/json'
                        -H "Accept: application/json"
                        -H "Authorization: Bearer CLIENT_SECRET"
                        -H "X-DietID-PartnerUserId: abc123"
                        -H "X-DietID-ClientId: CLIENT_TOKEN"
                        -d '{
                        "partnerUserId": "abc123",
                        "email": "example@dietid.com",
                        "firstName": "NameTest",
                        "lastName": "LastNameTest",
                        "healthGoals" : ["ControlBloodPressure"],
                        "chronicConditions" : ["ControlBloodPressure"],
                        "additionalParams": {},
                        "redirectUri": "https://example.com/assessment/complete",
                        "patientAlert": "This is a provider provided alert",
                        "height": 85,
                        "weight": 123,
                        "age": 45,
                        "DOB": "1999-11-12",
                        "postalCode": "90210",
                        "gender": "Male",
                        "desiredUsername": "desired_username_123",
                        "activityLevel": "HighlyActive",
                        "weightTrend": "Constant"
                        }`}
          />
        </Grid>
        <Grid
          item
          xs={2}
        >
          <h3>Example Response</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <CodeHighlighter
            code={`{
                          "success": true,
                          "url": "https://abc123.dietid.com/?u=ABC123...789XYZ"
                        }`}
          />
        </Grid>
        <Grid
          item
          xs={2}
        >
          <h3>Error Response</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <CodeHighlighter
            code={`{
                          "success": false,
                          "message": "Invalid client secret. Please check your Authorization header (Authorization: 'Bearer xxx')"
                        }`}
          />
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};
export default SSOV3;
